/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Search16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M6.994 1a5.994 5.994 0 014.906 9.438l2.807 2.807a1 1 0 010 1.415l-.047.047a1 1 0 01-1.415 0L10.438 11.9A5.994 5.994 0 116.994 1zm0 1.998a3.996 3.996 0 100 7.992 3.996 3.996 0 000-7.992z"
        />
    </AccessibleSVG>
);

export default Search16;
